<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2>Job Offers</h2>
    <v-flex>
      <v-row>
        <v-col cols="2">
          <v-text-field v-model="searchTerm" v-on:keyup.enter="getOffersToSetSalary" label="Search by keyword"></v-text-field>
        </v-col>
        <v-col>
          <v-switch v-model="salaryNotProcessed" @change="filterProcessed(salaryNotProcessed, 'manuallyProcessed')" label="Salary not processed"></v-switch>
        </v-col>
        <v-col>
          <v-switch v-model="notExpired" @change="getOffersToSetSalary" label="Not expired offers"></v-switch>
        </v-col>
        <v-col>
          <v-btn color="primary" @click="getOffersToSetSalary">Load Offers to set the Salary</v-btn>
        </v-col>
      </v-row>

      <v-data-table
        id="jobOffersTable"
        :items="jobOffersItems"
        :headers="tableHeaders"
        :items-per-page="25"
        @update:sort-desc="filterProcessed(salaryNotProcessed) && filterProcessed(notExpired, 'expireDate')"
      >
        <template v-slot:item.title="{item}">
          <router-link :to="{name: jobOfferDetailRoute, params: {id: item._id}}">{{item.title}}</router-link>
        </template>
        <template v-slot:item.manuallyProcessed="{item}">
          <v-icon v-if="item.manuallyProcessed" color="success">mdi-check</v-icon>
          <v-icon v-else color="error">mdi-cross</v-icon>
        </template>
      </v-data-table>
    </v-flex>
  </v-container>
</template>

<script>
  import api from '@/api/index';

  const tableHeaders = [
    {text: 'Title', value: 'title', width: 240},
    {text: 'Company', value: 'company.name'},
    {text: 'Posting date', value: 'postingDate'},
    {text: 'Expire date', value: 'expireDate'},
    {text: 'Processed', value: 'manuallyProcessed'}
  ];
  export default {
        name: "List",
        data() {
          return {
            searchTerm: null,
            jobOffers: [],
            jobOffersItems: [],
            salaryNotProcessed: true,
            notExpired: true,
            jobOfferDetailRoute: 'jobOfferSalaryReview',
            tableHeaders
          }
        },
        methods: {
          getOffersToSetSalary() {
            this.jobOfferDetailRoute = 'jobOfferSalaryReview';
            let params = {withSalary: true};
            if (this.searchTerm) {
              params.searchTerm = this.searchTerm;
            }
            if (this.notExpired) {
              params.notExpired = this.notExpired;
            }
            api.jobOffers.getFiltered(params).then(response => {
              this.jobOffers = response.data.data.jobOffers;
              this.filterProcessed(this.salaryNotProcessed, 'manuallyProcessed');
            })
          },
          filterProcessed(flag, field) {
            let jobOffersIds;
            this.jobOffersItems = flag ? this.jobOffers.filter(e => e[field] !== true) : this.jobOffers;
            jobOffersIds = this.jobOffersItems.map(e => e._id);
            this.$store.dispatch('setJobOffersList', jobOffersIds );
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/job-offers/List.vue